export const gemeindeSearchModeName = 'searchMode';
